<div class="container-fluid">
    <div class="container" #searchContainer>
        <div class="row align-items-center pad">
            <div class="col-md-2">
                <div class="label-align">
                    <label class="roboto-condensed-bold mb-0">CHOOSE AN ARTICLE:</label>
                </div>

            </div>
            <div class="col-md-10">
                <!-- Make this relative so the absolute autocomplete list is aligned -->
                <div class="search-input position-relative w-100">
                    <mat-form-field appearance="outline" class="w-100">

                        <input matInput type="text" [(ngModel)]="searchTerm" (keyup)="onSearchInput()" />
                    </mat-form-field>

                    <!-- Autocomplete List aligned properly below input -->
                    <div class="autocomplete-list" *ngIf="autocompleteList.length > 0">
                        <ul class="p-0 m-0">
                            <li class="ac-li" *ngFor="let item of autocompleteList" (click)="selectItem(item)">
                                {{ item.referenceProduct ? item.referenceProduct : item.nom }} -
                                {{ item.shortDescription?.fr_FR }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- search bar -->
    <div class="container-section-detail" *ngIf="displayDetail">
        <div class="content-wrap list-products-page">
            <div class="container">

                <div class="title-catalogue d-flex justify-content-between align-items-center">
                    <h2 class="roboto-condensed-bold">
                        {{ currentProduct?.shortDescription | translateDynamicLanguage }}
                    </h2>
                </div>
                <div class="wrap-general-info pb-5">
                    <div class="d-flex cotent-wrp">
                        <div class="group-img w-6 pr-2 imgbox">
                            <img [src]="selectedImage" alt="Product Image" class="product-image" />
                        </div>

                        <div class="group-info w-6 pl-2">
                            <div class="code">
                                <span>{{ 'Code' | translate }}:
                                    {{ currentProduct?.referenceProduct }}</span>
                            </div>
                            <div class="code">
                                <p>
                                    <strong>{{ 'Code EAN' | translate }}: </strong>{{ currentProduct?.gencodeProduct}}
                                </p>


                            </div>

                            <div class="description">
                                <p>
                                    <strong>{{
                                        'IRONSIDE.new-productDetail.DESCRIPTION' | translate
                                        }}: </strong>
                                    <span
                                        [innerHTML]="currentProduct?.longDescription | translateDynamicLanguage"></span>
                                </p>
                            </div>
                            <div class="row align-items-center">
                                <div class="col-md-6 title-catalogue">
                                    <h4>DOCUMENTS TO DOWNLOAD</h4>
                                </div>
                                <div class="col-md-6 text-end">
                                    <button class="btn btn-outline-primary" [disabled]="isOnlyoneResource"
                                        (click)="downloadAllResource()">
                                        DOWNLOAD ALL
                                    </button>
                                </div>
                                <div>
                                    <div class="list-documents container-wrap">
                                        <div class="wrapper-commercial" *ngFor="let document of this.downladeableDocs">
                                            <div (click)="onShowFile(document)"
                                                class="file-row flex items-center space-x-2 max-w-[250px] overflow-hidden">
                                                <img src="src-ironside/assets/images/file-text.png" alt="file"
                                                    style="width: 30px;" />
                                                <div class="file-texts flex flex-col overflow-hidden">
                                                    <span class="font-bold truncate w-full">{{ document.title }}</span>
                                                    <span class="truncate w-full">{{ document.title }}</span>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>


                            </div>
                        </div><p-dialog header="{{ 'File preview'  }}" [modal]="true" [(visible)]="visible"
                            [style]="{ width: '50%' }">
                            <div class="popup-del-row">
                                <div class="w-100 text-end"
                                    style="margin-bottom: 12px; display: flex; justify-content: flex-end">
                                    <a (click)="
                    downloadFile(fileSelected.url, fileSelected?.fileName, fileSelected?.origin)
                " class="btn-common p-2" style="display: flex; flex-direction: row; gap: 4px; width: fit-content">{{
                                        'Download' }}
                                        <span><mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner></span></a>
                                </div>
                                <div id="outerContainer" *ngIf="fileSelected.url" class="pdf-viewer-container">
                                    <div class="pdf-container" [ngClass]="{ loaded: pdfLoaded }">
                                        <span [ngSwitch]="fileSelected?.type">
                                            <p *ngSwitchCase="'pdf'">
                                                <pdf-viewer [src]="fileSelected.url || defaultImg" [rotation]="0"
                                                    [original-size]="false" [show-all]="true" [fit-to-page]="false"
                                                    [zoom]="1" [zoom-scale]="'page-width'" [stick-to-page]="false"
                                                    [render-text]="true" [external-link-target]="'blank'"
                                                    [autoresize]="true" [show-borders]="false"
                                                    style="max-width: 100; width: 102%; height: 80vh; max-height: 500px"
                                                    (page-rendered)="pageRendered($event)"
                                                    (after-load-complete)="pageComplete($event)"></pdf-viewer>
                                            </p>
                                            <p *ngSwitchCase="'pptx'">
                                                <iframe [src]="sanitizedUrl(fileSelected.url)" width="100%"
                                                    height="600px" frameborder="0"></iframe>
                                            </p>
                                            <div *ngSwitchDefault style="width: 100%; text-align: center">
                                                <img [src]="fileSelected.url" alt="img" height="500"
                                                    style="object-fit: scale-down" />
                                            </div>
                                        </span>

                                        <div class="loading-file" *ngIf="loadingFile">
                                            <mat-spinner [diameter]="50"></mat-spinner>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </p-dialog>

                    </div>
                </div>
            </div>
        </div>
    </div>